import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import automationKeys from '@/api/queries/automations/keyFactory';
import { graphql } from '@/gql';
import {
  DeleteListedAutomationMutation,
  DeleteListedAutomationMutationVariables,
} from '@/gql/graphql';

const DeleteAutomation = graphql(`
  mutation DeleteListedAutomation($id: ID!) {
    deleteAutomation(id: $id)
  }
`);

const useDeleteAutomation = (
  options?: UseMutationOptions<
    DeleteListedAutomationMutation,
    unknown,
    DeleteListedAutomationMutationVariables['id']
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation({
    mutationFn: (id) => gqlClient.request(DeleteAutomation, { id }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: automationKeys.automations(),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useDeleteAutomation;
